module.exports = __webpack_public_path__ + "static/media/icon_logout.c3a46e2b.svg";